import { defaultMarkupAttributes, ShapesColors, ShapesDefaultNames, ShapesNames } from '../utils';
import { defaultTextAttributes } from '../utils';

export const InputAttributes = {
  type: ShapesNames.INPUT_SHAPE,
  size: { width: 120, height: 40 },
  allowOrthogonalResize: false,
  defaultName: ShapesDefaultNames.INPUT_SHAPE,
  attrs: {
    body: {
      fill: '#FFFFFF',
      stroke: ShapesColors.INPUT_SHAPE,
      rx: 2,
      ry: 2,
      strokeWidth: 2
    },
    label: {
      ...defaultTextAttributes,
      textWrap: {
        text: ShapesDefaultNames.INPUT_SHAPE,
        width: -40,
        height: -10,
        ellipsis: '...'
      }
    },
    iconBackground: {
      width: 30,
      height: 40,
      fill: ShapesColors.INPUT_SHAPE,
      x: 0,
      y: 1
    }
  },
  data: {
    name: ShapesDefaultNames.INPUT_SHAPE,
    contents: null
  },
  markup: [...defaultMarkupAttributes]
};
